import BaseStore from './base-store.js'
import StoreProxy from './store_proxy.js'
import {API2_SHCOMPANIES} from 'consts/api2'



import * as $utils from 'utils';
export class ShCompany extends BaseStore {
  constructor(values = {}) {
    super({
      id: crypto.randomUUID(),
      name: undefined,
      linkedin_id: undefined,
      website_url: undefined,
      logo_url: undefined,
      followers_cnt: undefined,
      ...values
    })
  }

  async uploadLogo(file) {
    file.filename = this.id
      
    const formData = new FormData()
    formData.append('company_id', this.id)
    formData.append('file', file)

    const {logo_url} = await this._rest.put(`${API2_SHCOMPANIES}/logo`, formData, {force_form_data: true})
    this._state.logo_url = null
    await $utils.timers.wait(5000) // allow cloudfront cache to be invalidated  
    this._state.logo_url = logo_url
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    const {bleach} = await rest.patch(`${API2_SHCOMPANIES}/${this.id}`, to_write)
    this._bleach(bleach)
  }
}


export class ShCompanies extends BaseStore {
  constructor() {
    super({
      view_items: [],
      view_total: 0,
      total: 0,
    })
  }

  getCompany(id) {
    return this._state.view_items.find(x => x.id === id)
  }

  async newCompany(data) {
    const {bleach} = await this._rest.post(API2_SHCOMPANIES, data)
    return new ShCompany(bleach)
  }

  async mergeCompanies(data){
    return await this._rest.post(`${API2_SHCOMPANIES}/merge`, data)
  }

  async doLoad(rest, params) {
    const result = await (rest || this._rest).get(API2_SHCOMPANIES, params)
    this._state.view_items = result.view_items.map(data => new ShCompany(data))
    this._state.view_total = result.view_total
    this._state.total = result.total
  }
}


const companies = StoreProxy(new ShCompanies(), {array_prop: 'view_items'})
export default companies
